import React from 'react';
import PropTypes from 'prop-types';

import RecruitLinkCard from '../../../../components/recruit-link-card';
import Card from '../card';
import { constructScheduleURL } from '../constants';

import { Text } from '../styles';

const TEXT = 'Set up your schedule and click "Submit Availability" below. '
  + 'We\'ll generate a link that you can share with your participants.';

const ScheduleLink = (props) => {
  const {
    project,
  } = props;

  const {
    submittedAvailabilities,
    participantsSource,
    testType,
    recruitParticipantToken,
  } = project;

  const isRyo = participantsSource === 'company';
  const showText = !submittedAvailabilities;
  const showLink = submittedAvailabilities && isRyo;
  const hideCard = !isRyo;

  const url = constructScheduleURL(project);

  return (
    <Card
      hidden={hideCard}
      title="Link to share your schedule"
    >
      {showText && <Text>{TEXT}</Text>}
      {showLink && recruitParticipantToken && recruitParticipantToken.token && (
        <RecruitLinkCard
          testType={testType}
          raw
          url={url}
        />
      )}
    </Card>
  );
};

ScheduleLink.propTypes = {
  project: PropTypes.shape({
    id: PropTypes.string,
    submittedAvailabilities: PropTypes.bool.isRequired,
    participantsSource: PropTypes.string,
    testType: PropTypes.string,
    recruitParticipantToken: PropTypes.shape({
      token: PropTypes.string,
    }),
    surveys: PropTypes.PropTypes.arrayOf(PropTypes.shape({
      surveyType: PropTypes.string,
    })),
    projectConsentForms: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  segment: PropTypes.shape({
    id: PropTypes.string,
    surveys: PropTypes.arrayOf(PropTypes.shape({
      surveyType: PropTypes.string,
    })),
  }).isRequired,
};

export default ScheduleLink;
